import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { queryClient } from './lib/queryClient';
import type { AuthContextValue } from './features/auth/authContext';

/**
 * TanStack Router のルーターインスタンス。
 *
 * - context に auth / queryClient を注入
 * - auth は main.tsx 側で RouterProvider に渡す時点で確定する
 */
export const router = createRouter({
  routeTree,
  context: {
    // auth は main.tsx で上書き注入するため placeholder
    auth: undefined!,
    queryClient,
  },
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export interface RouterContext {
  auth: AuthContextValue;
  queryClient: typeof queryClient;
}
